import React from "react"
import { useTranslation } from "react-i18next"
import { View, StyleSheet, Image, Text } from "@react-pdf/renderer"

import { domainPathname } from "utils/functions"
import dateService from "services/date"
import {
	MFC_OPERATOR,
	BC_OPERATOR,
	DK_OPERATOR,
	MFC_RETAIL_GENDER,
	MFC_SUNN_GENDER,
	MFC_INTER_GENDER,
	MC_OPERATOR,
} from "utils/constants"

import { styles } from "./PDFStyles"
import { LocalBike } from "models"

type PDFHeaderProps = {
	bike: LocalBike
	operatorGender: string
}

// Header component
const PDFHeader: React.FC<PDFHeaderProps> = ({ bike, operatorGender }) => {
	const { t } = useTranslation()

	const headerStyles = StyleSheet.create({
		header: {
			flexDirection: "row",
			alignItems: "center",
			justifyContent: "space-between",
		},
		leftColumn: {
			width: 150,
			marginLeft: "auto",
		},
	})

	return (
		<View style={headerStyles.header}>
			<View style={headerStyles.leftColumn}>
				{(bike.operator === BC_OPERATOR || bike.operator === "BY") && (
					<Image src={`${domainPathname}/BicyCode-logoBleu.jpg`} style={[styles.image]} />
				)}

				{bike.operator === DK_OPERATOR && (
					<Image src={`${domainPathname}/Decathlon-logo.jpg`} style={[styles.image]} />
				)}

				{bike.operator === MC_OPERATOR && (
					<Image src={`${domainPathname}/logo_moustache.jpg`} style={[styles.image]} />
				)}

				{bike.operator === MFC_OPERATOR && operatorGender === null && (
					<Image src={`${domainPathname}/MFC_logo.jpg`} style={[styles.image]} />
				)}

				{bike.operator === MFC_OPERATOR && operatorGender === MFC_RETAIL_GENDER && (
					<Image src={`${domainPathname}/MFC_logo.jpg`} style={[styles.image]} />
				)}

				{bike.operator === MFC_OPERATOR && operatorGender === MFC_SUNN_GENDER && (
					<Image src={`${domainPathname}/logo_sunn.jpg`} style={[styles.image]} />
				)}

				{bike.operator === MFC_OPERATOR && operatorGender === MFC_INTER_GENDER && (
					<Image src={`${domainPathname}/logo_intersport.jpg`} style={[styles.image]} />
				)}

				<Text style={[styles.p]}>
					{t("pdf.the", { ns: "bike" })}
					{dateService.formatDate(new Date(), "dd/MM/y")},
				</Text>
			</View>
		</View>
	)
}

export default PDFHeader
